import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { selectGenericForms } from 'src/app/commons/constants/store/parameters.selector';
import { SharedFormValidationsService } from 'src/app/commons/services/sharedFormValidations.service';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/app.state';
import { take } from 'rxjs';
import { UserGraphQLService } from 'src/app/graphQL/services/user/userGraphQL.service';

@Injectable()
export class RegisterUserForm {
  phonevalidators: any;
  GENERAL_MODULE:number=5;
  constructor(
    private fb: FormBuilder,
    public _sharedFormValidationsService: SharedFormValidationsService,
    private store: Store<AppState>,
       public _userService: UserGraphQLService,
  ) {


  }

  /**
   * Generates a FormGroup for user details creation with predefined validation rules.
   *
   * @returns A FormGroup with controls for firstName, lastName, emailAddress,
   * phoneNumber, birthday, fiscalId, jobTitle, requestedPermissions,
   * termsAndConditions, and termsAcceptedDate.
   */
  generateFormGroup(): FormGroup {
    const validators = [Validators.required];
  
if (this.phonevalidators) {
  validators.push(this.phonevalidators);
}

    return this.fb.group({
      firstName: [
        '',
        [
          Validators.required,
          Validators.minLength(2),
          Validators.maxLength(50),
          Validators.pattern(/^[a-zA-ZÀ-ÿ\s]+$/),
        ],
      ], // Allow letters and spaces, including accents
      lastName: [
        '',
        [
          Validators.required,
          Validators.minLength(2),
          Validators.maxLength(50),
          Validators.pattern(/^[a-zA-ZÀ-ÿ\s]+$/),
        ],
      ],
      documentNumberId: [
        '',
        [
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(50),
        ],
      ],
      emailAddress: ['', [Validators.required, Validators.email]], // Check format
      phoneNumber: ['', validators], // Validate 10-digit phone numbers
      birthday: [null],
      fiscalId: ['', [Validators.required, Validators.pattern(/^[0-9-]+$/)]], // Validate numeric string with optional hyphens (e.g., 44-46546)
      jobTitle: [
        '',
        [
          Validators.minLength(2),
          Validators.maxLength(100),
          Validators.pattern(/^[a-zA-ZÀ-ÿ\s.]+$/),
        ],
      ],
      cityId: [null, Validators.required],
      stateCountryId: [null, Validators.required],
      createdDate: [null],
      salesforceSync: [false],
      requestedPermissions: this.fb.array([]), // Permissions as FormArray
      termsAndConditions: [false, Validators.requiredTrue], // Terms must be accepted
      termsAcceptedDate: [null], // Track date when terms were accepted
      habeasData: [false, Validators.requiredTrue], // Personal data usage policy acceptance
      isFederated: [false],
      isInvite: [false],
      storeId: [environment.storeIdComplete],
    });
  }

  /**
   * Generates a FormGroup for user details creation with predefined validation rules.
   *
   * @returns A FormGroup with controls for firstName, lastName, emailAddress,
   * phoneNumber, birthday, fiscalId, jobTitle, requestedPermissions,
   * termsAndConditions, and termsAcceptedDate.
   */
  generateFormGroupFederated(user: any): FormGroup {
        const validators = [Validators.required];
if (this.phonevalidators) {
  validators.push(this.phonevalidators);
}
    return this.fb.group({
      firstName: [user.name], // Allow letters and spaces, including accents
      lastName: [user.lastName],
      documentNumberId: [
        '',
        [
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(50),
        ],
      ],
      emailAddress: [user.email, [Validators.required, Validators.email]], // Check format
      phoneNumber: [0,validators ], // Validate 10-digit phone numbers
      birthday: [null],
      fiscalId: ['', [Validators.required,Validators.pattern(/^[0-9-]+$/)]], // Validate that it is a numeric string, adjust based on country format
      jobTitle: [
        '',
        [
          Validators.minLength(2),
          Validators.maxLength(100),
          Validators.pattern(/^[a-zA-ZÀ-ÿ\s.]+$/),
        ],
      ],
      cityId: [null, Validators.required],
      stateCountryId: [null, Validators.required],
      createdDate: [null],
      salesforceSync: [false],
      requestedPermissions: this.fb.array([]), // Permissions as FormArray
      termsAndConditions: [false, Validators.requiredTrue], // Terms must be accepted
      termsAcceptedDate: [null], // Track date when terms were accepted
      habeasData: [false, Validators.requiredTrue], // Personal data usage policy acceptance
      isFederated: [true],
      isInvite: [false],
      storeId: [environment.storeIdComplete],
    });
  }
  /**
   * Adds a new permission control to the requestedPermissions FormArray.
   *
   * @param permissionId - The ID of the permission to be added.
   */
  addPermission(permissionId: string): void {
    const permissionsArray = this.getRequestedPermissions();
    permissionsArray.push(this.fb.control(permissionId));
  }

  /**
   * Removes a permission control from the requestedPermissions FormArray.
   *
   * @param index - The index of the permission to be removed.
   */
  removePermission(index: number): void {
    const permissionsArray = this.getRequestedPermissions();
    if (index >= 0) {
      permissionsArray.removeAt(index);
    }
  }

  /**
   * Retrieves the FormArray of requested permissions.
   *
   * @returns The FormArray for requested permissions.
   */
  getRequestedPermissions(): FormArray {
    return this.fb.array([]);
  }
}
